import {identity} from 'lodash';

export function convertUserToParticipant(user) {
    return {
        categories: {},
        program_selection: [],
        sortstring: [user.last_name?.replace(/ /g, '').toUpperCase(), user.first_name?.replace(/ /g, '').toUpperCase()].filter(identity).join(''),
        ...user,
        _fakeParticipant: true,
        user_id: user.id,
    };
}
